<template>
  <div :class="isTextLeft ? 'medium-text-left' : 'text-center'">
    <picture>
      <img
        id="qrcode-image"
        class="margin-bottom-xs"
        alt="QRCode"
        :src="fetchQRCodeImage"
        :fetchpriority="priority"
        :loading="priority === 'high' ? 'eager' : 'lazy'"
      />
    </picture>
    <div v-if="!hideNumber" id="qrcode-number" v-text="qrcodeNumber"></div>
    <div
      id="scan-text"
      :class="{
        'margin-left-s': qrcodeUrl && isTextLeft,
      }"
      v-text="scanText"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    qrcodeNumber: {
      type: String,
      default: '',
    },
    hideNumber: Boolean,
    scanText: {
      type: String,
      default: '',
    },
    isTextLeft: Boolean,
    qrcodeUrl: {
      type: String,
      default: '',
    },
    priority: {
      type: String,
      default: 'auto',
    },
  },
  computed: {
    fetchQRCodeImage() {
      if (this.qrcodeUrl) return this.qrcodeUrl;
      return `/api/ordermodsreturns/v1/returns/barcodegenerator?no=${this.qrcodeNumber}&add_hex=false`;
    },
  },
};
</script>

<style lang="scss" scoped>
#qrcode-image {
  width: rem-calc(199);
}
</style>
